import { CommandBuilder } from './components/CommandBuilder';
import { DropZone } from './components/DropZone';
import { ExcludedView } from './components/ExcludedView';
import { ExternalLinksView } from './components/ExternalLinksView';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { ImagesView } from './components/ImagesView';
import { PerformanceView } from './components/PerformanceView';
import { TableView } from './components/TableView';
import { TreeView } from './components/TreeView';
import { WarningsSummary } from './components/WarningsSummary';
import { WarningsView } from './components/WarningsView';
import { useStore, type Tab } from './store';

const TAB_LABELS: Record<Tab, string> = {
  tree: 'ツリー',
  table: 'テーブル',
  performance: 'パフォーマンス',
  warnings: '警告',
  external: '外部リンク',
  images: '画像',
  excluded: '除外',
};

export function App() {
  const data = useStore((s) => s.data);
  const showCommandBuilder = useStore((s) => s.showCommandBuilder);
  const tab = useStore((s) => s.activeTab);
  const setTab = useStore((s) => s.setActiveTab);

  // コマンドビルダー画面はデータの有無にかかわらず最優先で表示
  if (showCommandBuilder) return <CommandBuilder />;

  if (!data) {
    return (
      <div className="flex min-h-screen flex-col">
        <div className="flex-1">
          <DropZone />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <Header />
      <WarningsSummary />
      <nav className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl gap-1 px-6">
          {(Object.keys(TAB_LABELS) as Tab[]).map((key) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`border-b-2 px-4 py-3 text-sm font-medium transition ${
                tab === key
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-slate-600 hover:text-slate-900'
              }`}
            >
              {TAB_LABELS[key]}
              {key === 'warnings' && data.warnings.length > 0 && (
                <span className="ml-1.5 rounded-full bg-amber-100 px-1.5 py-0.5 text-xs text-amber-800">
                  {data.warnings.length}
                </span>
              )}
            </button>
          ))}
        </div>
      </nav>
      <main
        className={`mx-auto w-full flex-1 px-6 py-6 ${
          tab === 'table' ? 'max-w-none' : 'max-w-7xl'
        }`}
      >
        {tab === 'tree' && <TreeView />}
        {tab === 'table' && <TableView />}
        {tab === 'performance' && <PerformanceView />}
        {tab === 'warnings' && <WarningsView />}
        {tab === 'external' && <ExternalLinksView />}
        {tab === 'images' && <ImagesView />}
        {tab === 'excluded' && <ExcludedView />}
      </main>
      <Footer />
    </div>
  );
}
